<div class="Padre">
    <div style="background-color: #FFFFFF;" class="row justify-content-center me-0">
        <div class="desktop pe-0">
            <banner-app [Fixtop]="''" [retroSelected]=false [Loader]=true [showPromo]="true"></banner-app>
        </div>
        <br><br>
        <div class="mobile">
            <br><br><br><br><br><br><br>
        </div>

        <div class="img-contenedora col-12 col-sm-8 col-lg-6 my-3">
            <app-webm-player src="./assets/img/loader.webm" alt="Seguro de moto precio" width="100%" height="auto"
                cssClass="video-background" />
        </div>
        <div class="mensajeLoading img-contenedora pe-0">
            Estamos consultando tus datos...
        </div>
    </div>
</div>